// @flow
import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SimpleBar from 'simplebar-react';
import { SearchFilter } from 'components/molecules/searchFilter';
import { useViewport } from 'components/templates/viewportProvider';
import { VenueFilter } from 'components/atoms/venueFilters';
import { GenreFilter } from 'components/atoms/genreFilter';
import { CityFilter } from 'components/atoms/cityFilter';
import { EventActions } from 'modules/event/actions';
import { EventSelector } from 'modules/event/selector';
import chevronRightIcon from 'assets/images/rightb.png';
import type { ActiveEventFilters, EventFilters } from 'types/filter';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  filters: EventFilters | null,
  activeFilters: ActiveEventFilters | null,
  toggleUpcomingEventFilter: (type: string, value: number) => void,
  clearUpcomingEventFilters: () => void,
};

const UpcomingEventFiltersModal = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    isOpen,
    onClosePress,
    filters,
    activeFilters,
    toggleUpcomingEventFilter,
    clearUpcomingEventFilters,
  } = props;

  if (!filters) {
    return null;
  }

  const onClose = () => {
    onClosePress();
  };

  const toggleVenue = option => {
    toggleUpcomingEventFilter('venue', option.venueId);
  };

  const toggleGenre = option => {
    toggleUpcomingEventFilter('genre', option.genreId);
  };

  const toggleCity = option => {
    toggleUpcomingEventFilter('city', option.cityId);
  };

  const toggleArtist = option => {
    toggleUpcomingEventFilter('artist', option.artistId);
  };

  const clearAllFilters = e => {
    e.preventDefault();
    clearUpcomingEventFilters();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`upcoming-events-filters-overlay-content ${
        isMobile ? 'mobile' : ''
      }`}
    >
      <div className={'upcoming-events-filters-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        {!isMobile && <span className={'modal-title'}>Filters</span>}
        <a className={'modal-button'} onClick={clearAllFilters} href={'#'}>
          Clear All
        </a>
        <SimpleBar autoHide={true} style={{ height: '100%' }}>
          <div className={'upcoming-events-filters-content'}>
            <div className={'filters-header'}>
              <h3>Looking for something specific?</h3>
              {!isMobile && (
                <p>Filter by venue, genre, city, and artist name.</p>
              )}
            </div>
            <div className={'filter-set'}>
              <VenueFilter
                options={filters.venue}
                activeFilters={activeFilters.venue}
                toggleFilter={venue => toggleVenue(venue)}
              />
              <GenreFilter
                options={filters.genre}
                activeFilters={activeFilters.genre}
                toggleFilter={genre => toggleGenre(genre)}
              />
              {!isMobile && (
                <CityFilter
                  options={filters.city}
                  activeFilters={activeFilters.city}
                  toggleFilter={city => toggleCity(city)}
                />
              )}
              <SearchFilter
                title={'Artist'}
                options={filters.artist}
                values={activeFilters.artist}
                onClick={option => toggleArtist(option)}
                isArtistSearch={true}
              />
            </div>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    filters: EventSelector.getUpcomingEventFilters(state),
    activeFilters: EventSelector.getActiveUpcomingEventFilters(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleUpcomingEventFilter, clearUpcomingEventFilters } = EventActions;
  return bindActionCreators(
    {
      toggleUpcomingEventFilter,
      clearUpcomingEventFilters,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpcomingEventFiltersModal);

export { connectedComponent as UpcomingEventFiltersModal };
